<div [class]="wrapperClass">
  <div class="pointer-events-none" [class]="ringClass" aria-hidden="true"></div>
  @if (label) {
    <span class="text-t-base text-t-muted">{{ label }}</span>
  }
</div>
